<template>
  <div class="minor-page">
    <!-- 背景装饰 -->
    <div class="ambient">
      <div class="ambient-orb orb-a"></div>
      <div class="ambient-orb orb-b"></div>
    </div>

    <div class="minor-wrap">
      <header class="minor-hero">
        <div class="hero-badge">政策与协议</div>
        <h1 class="minor-title">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/></svg>
          未成年人保护说明
        </h1>
        <p class="minor-lead">依据《中华人民共和国未成年人保护法》《未成年人网络保护条例》及国家网信办《移动互联网未成年人模式建设指南》制定，保护未成年人在本平台的网络权益。</p>
      </header>

      <section class="minor-card">
        <h2>一、青少年模式</h2>
        <p>本平台提供<b>青少年模式</b>，开启后平台将自动启用以下保护措施：</p>
        <ul>
          <li><b>使用时段限制</b>：默认每日 22:00 至次日 6:00 为宵禁时段，期间暂停提供服务；</li>
          <li><b>使用时长限制</b>：默认每日使用时长不超过 60 分钟，可由监护人调整；</li>
          <li><b>休息提醒</b>：连续使用满 30 分钟将主动发出休息提醒，保护未成年人视力与身心健康；</li>
          <li><b>消费保护</b>：开启期间<b>禁止一切充值、开通会员及购买行为</b>，严于国家有关消费限额标准；</li>
          <li><b>内容保护</b>：仅展示适龄内容池内的作品，内容池外的漫画详情与章节阅读将被限制访问。</li>
        </ul>
      </section>

      <section class="minor-card">
        <h2>二、分龄适龄推荐</h2>
        <p>依据《移动互联网未成年人模式建设指南》分龄原则，开启青少年模式时可选适龄范围（8-12周岁 / 12-16周岁 / 16-18周岁），平台据此优先展示适龄内容并标注适龄信息。本平台适龄提示级别为 <b>16+</b>。</p>
      </section>

      <section class="minor-card">
        <h2>三、监护人指引</h2>
        <p>青少年模式提供<b>独立密码</b>保护：开启、关闭、修改时长与宵禁设置、修改密码均需验证密码，未成年人无法自行绕过限制。建议监护人：</p>
        <ul>
          <li>为未成年人开启青少年模式，并设置监护人独立密码；</li>
          <li>通过"今日使用概况"关注未成年人使用情况；</li>
          <li>加强对未成年人使用网络行为的引导和监督，合理安排使用时间，预防沉迷。</li>
        </ul>
      </section>

      <section class="minor-card">
        <h2>四、内容与功能管理</h2>
        <ul>
          <li>平台不设置以应援集资、投票打榜、刷量控评为主题的网络社区、群组、话题；</li>
          <li>平台不向未成年人提供诱导其沉迷的产品和服务，及时修改可能造成未成年人沉迷的内容、功能和规则；</li>
          <li>平台依法履行信息内容管理主体责任，防范外链信息内容风险，不呈现危害或可能影响未成年人身心健康的信息。</li>
        </ul>
      </section>

      <section class="minor-card highlight-card">
        <h2>五、投诉举报渠道</h2>
        <p>平台设立未成年人保护专项投诉举报渠道。如您发现危害未成年人身心健康的内容、诱导沉迷的功能，或未成年人未经监护人同意进行充值消费，请随时联系我们，平台将在受理后及时核实处置。</p>
        <div class="hotline">
          <span>未成年人保护专线（客服）</span>
          <strong>13810795803</strong>
        </div>
        <p class="report-extra">违法和不良信息举报：12377.cn</p>
      </section>

      <section class="minor-card">
        <h2>六、防沉迷制度公示</h2>
        <p>平台依据《未成年人网络保护条例》第四十二条建立防沉迷制度，每年向社会公布防沉迷工作情况，接受社会监督。本说明最后更新日期：2026年9月7日。</p>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MinorProtectionPage',
};
</script>

<style scoped>
.minor-page {
  min-height: 100vh;
  position: relative;
  overflow: hidden;
}

.ambient {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.ambient-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(90px);
  opacity: 0.35;
}

.orb-a {
  width: 360px;
  height: 360px;
  top: -120px;
  right: -80px;
  background: rgba(79, 172, 254, 0.35);
}

.orb-b {
  width: 300px;
  height: 300px;
  bottom: -100px;
  left: -80px;
  background: rgba(0, 242, 254, 0.22);
}

.minor-wrap {
  position: relative;
  max-width: 860px;
  margin: 0 auto;
  padding: 48px 24px 64px;
}

.minor-hero {
  text-align: center;
  margin-bottom: 36px;
}

.hero-badge {
  display: inline-block;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 2px;
  color: var(--brand);
  border: 1px solid rgba(79, 172, 254, 0.4);
  background: rgba(79, 172, 254, 0.12);
  border-radius: 99px;
  padding: 5px 16px;
  margin-bottom: 18px;
}

.minor-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  font-size: 30px;
  font-weight: 800;
  color: var(--text);
  margin: 0 0 14px;
}

.minor-title svg {
  width: 34px;
  height: 34px;
  color: var(--brand);
}

.minor-lead {
  font-size: 14px;
  line-height: 1.8;
  color: var(--text-dim);
  max-width: 640px;
  margin: 0 auto;
}

.minor-card {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 16px;
  padding: 26px 28px;
  margin-bottom: 18px;
}

.minor-card h2 {
  font-size: 18px;
  font-weight: 700;
  color: var(--text);
  margin: 0 0 12px;
  padding-left: 12px;
  border-left: 4px solid var(--brand);
}

.minor-card p {
  font-size: 14px;
  line-height: 1.9;
  color: var(--text-dim);
  margin: 0 0 10px;
}

.minor-card b {
  color: var(--brand);
}

.minor-card ul {
  margin: 0;
  padding-left: 20px;
}

.minor-card li {
  font-size: 14px;
  line-height: 1.9;
  color: var(--text-dim);
}

.hotline {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 14px 18px;
  background: var(--brand-soft);
  border: 1px solid rgba(79, 172, 254, 0.35);
  border-radius: 12px;
  margin: 6px 0 10px;
}

.hotline span {
  font-size: 13px;
  color: var(--text-dim);
}

.hotline strong {
  font-size: 20px;
  color: var(--brand);
  letter-spacing: 1px;
}

.report-extra {
  font-size: 12px;
  color: var(--text-faint);
  margin: 0;
}

@media (max-width: 768px) {
  .minor-wrap {
    padding: 32px 16px 48px;
  }

  .minor-title {
    font-size: 24px;
  }

  .minor-card {
    padding: 20px 18px;
  }
}
</style>
